<div class="flex pt-2" appManageValidatorDisplay [control]="formControl">
  <cap-textarea
    [formControl]="formControl"
    [label]="props.label"
    [hasTooltip]="props.tooltip"
    [id]="key"
    [maxlength]="props?.maxLength"
    [placeholder]="props.placeholder">
    <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
  </cap-textarea>
</div>
